import { render, staticRenderFns } from "./locationShow.vue?vue&type=template&id=a84a24c2&scoped=true"
import script from "./locationShow.vue?vue&type=script&lang=js"
export * from "./locationShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84a24c2",
  null
  
)

export default component.exports